import {Modal} from 'components/base-modal/Modal'
import {connectService} from 'components/service/connectService'
import {useFormik} from 'formik'
import {useNotification} from 'hooks/useNotification'
import {useContext, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {ErrorCode} from 'utility/http-utils'
import {Roles, getInitials} from 'utility/utility'
import {SuperAdminSchema} from './schema'
import {useConfirm} from 'hooks/useConfirm'
import feathers from 'utility/client'
import {ValidationError} from 'components/validation-error/ValidationError'
import {NavigationContext} from 'modules/dashboard/NavigationContext'

export const SuperAdmins = connectService(
  props => {
    const {list, loading, Loader, Placeholder, Paginator} = props
    const notify = useNotification()
    const confirm = useConfirm()
    const {setTitle} = useContext(NavigationContext)

    const [visible, setVisible] = useState(false)

    useEffect(() => {
      setTitle('Super Administrators')
    }, [])

    const onRemove = user => {
      const name = `${user.firstName} ${user.lastName}`

      confirm({
        title: `Confirm deletion of super admin user`,
        message: `Are you sure you want to remove the user ${name}? Once account removed, ${name} will not be able to login in admin portal!`,
        onConfirm: async () => {
          console.log('called remove business')
          feathers.service('user').remove(user._id)
        }
      })
    }

    const formik = useFormik({
      initialValues: {
        firstName: '',
        lastName: '',
        email: ''
      },
      validationSchema: SuperAdminSchema,
      onSubmit: async data => {
        feathers
          .service('user')
          .create({
            ...data,
            permissions: [Roles.superAdmin]
          })
          .catch(e => {
            const notification =
              e.code === ErrorCode.Conflict
                ? 'User already exist, can not make existing user as super admin!'
                : 'Something wrong, Please try again!'

            notify({
              notification,
              variant: 'danger'
            })
          })
        setVisible(false)
      },
      enableReinitialize: true
    })

    return (
      <>
        <div className="table-responsive-mask">
          <div className="table-responsive">
            <table className="vw-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>&nbsp; </th>
                </tr>
              </thead>
              <tbody>
                {list.length ? (
                  list.map(item => (
                    <tr key={item._id}>
                      <td>
                        <Link className="no-link-btn">
                          <div className="vw-table__name">
                            <div className="vw-table__name__no-img vw-icon-bg">
                              {getInitials(`${item?.firstName} ${item?.lastName}`)}
                            </div>{' '}
                            {`${item?.firstName} ${item?.lastName}`}
                          </div>
                        </Link>
                      </td>

                      <td>{item.email}</td>
                      <td>
                        <button onClick={() => onRemove(item)} className="btn btn-danger">
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))
                ) : loading ? (
                  <Loader colSpan={6} />
                ) : (
                  <Placeholder colSpan={6} placeholder="No Super Admins" />
                )}
              </tbody>
            </table>
            <div className="vw-group-button">
              <button
                className="btn btn-add btn-add--lg vw-tab-group-button"
                onClick={() => setVisible(true)}
              >
                <i className="fal fa-plus"></i>
              </button>
            </div>
          </div>
          {Paginator({className: 'd-flex flex-row-reverse mt-2'})}
        </div>
        <Modal
          open={visible}
          onClose={() => setVisible(false)}
          center
          title="Add Super Admin"
          confirmTitle="Save Super Admin"
          cancelTitle="Cancel"
          onCancel={() => setVisible(false)}
          onConfirm={formik.handleSubmit}
        >
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>First Name</label>
                <input
                  type="text"
                  placeholder="First name"
                  className="form-control"
                  name="firstName"
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                />
                <ValidationError formik={formik} property="firstName" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  className="form-control"
                  placeholder="Last name"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                />
                <ValidationError formik={formik} property="lastName" />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Email"
              value={formik.values.email}
              onChange={formik.handleChange}
            />
            <ValidationError formik={formik} property="email" />
          </div>
        </Modal>
      </>
    )
  },
  'user',
  {
    query: {
      $populate: ['distributor', 'reseller'],
      permissions: 'super-admin'
    }
  }
)
